<template>
  <div class="wrapper">
    <div>
      <div class="logo-wrapper">
        <div class="logo">
          <img :src="logoUrl()" href="/" />
        </div>
      </div>
      <div class="card login-card">
        <form @submit="e => e.preventDefault()">
          <div class="form">
            <div>
              <div class="form-group">
                <input
                  id="email"
                  type="email"
                  v-bind:placeholder="$t('general.email')"
                  name="email"
                  value=""
                  required
                  autofocus
                  screen="login"
                  v-model="email"
                  :class="{
                    'is-invalid': error,
                    'form-control': true,
                    textfield: true
                  }"
                />
                <!-- <div class="pre-icon os-icon os-icon-user-male-circle"></div> -->

                <span class="invalid-feedback" v-if="error">
                  <strong>{{ $t("login.credentials_dont_match") }}</strong>
                </span>
              </div>
              <div class="form-group">
                <input
                  id="password"
                  type="password"
                  :class="{
                    'is-invalid': error,
                    'form-control': true,
                    textfield: true
                  }"
                  v-bind:placeholder="$t('general.password')"
                  name="password"
                  v-model="password"
                  screen="login"
                  required
                />
                <!-- <div class="pre-icon os-icon os-icon-fingerprint"></div> -->
              </div>
              <button class="button login-button" color="primary" size="max" screen="login" @click="onLogin">
                {{ $t("login.login") }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { ReportFilterStore } from "../../store/ReportFilterStore";
import { NewReportStore } from "@/store/NewReportStore";
import { CompanyStore } from "@/store/CompanyStore";

export default {
  name: "Login",
  data() {
    return {
      email: null,
      password: null,
      error: false
    };
  },
  mounted() {
    console.log("Component mounted.");
  },
  methods: {
    ...mapActions("userStore", ["login"]),
    ...mapActions({
      fetchFileCategories: "fileStore/loadFileCategories",
      fetchProductInfo: "productStore/fetchInfo"
    }),
    onLogin() {
      this.login({
        email: this.email,
        password: this.password
      })
        .then(r => {
          if (r) {
            this.error = false;
            this.fetchFileCategories();
            this.fetchProductInfo();
            NewReportStore.getPrintPdfSettings();
            CompanyStore.loadAvailableCompanies();
            this.$router.push("/dashboard");
          } else {
            this.error = true;
          }
        })
        .catch(e => {
          console.log(e);
          this.error = true;
        });
    },
    logoUrl() {
      const hostname = window.location.hostname;
      if (hostname.includes("avvio-cedoon-portal-sta")) {
        return "/svg/logo/logo_login.svg";
      }

      return "/svg/logo/logo_login.svg";
    }
  }
};
</script>

<style scoped lang="scss">
@import "./src/assets/theme/_variables.scss";
.logo-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: $spacing-unit * 5;
}
.logo {
  width: 95%;
}
.login-card {
  background-color: $white;
  min-width: 400px;
  height: auto;
  padding: $spacing-unit * 4;
  display: flex;
  align-content: flex-start;
  justify-content: center;
  align-content: flex-start;
  flex-direction: column;
}
.wrapper {
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>
